import { Form, Grid, Label } from 'semantic-ui-react'
import styled from 'styled-components'

export const StyledGrid = styled(Grid)`
  .row {
    margin-bottom: 1rem !important;
  }
  .percent {
    font-size: 15px !important;
    font-weight: bold;
    margin-left: 30%;
  }
`;

export const GenElectricityWrapper = styled.div`
margin-top: 2em;
 .field {
  margin-bottom: .2em !important;
 }
`
export const MilkProductionField = styled(Form.Field)`
display: flex;
flex-direction: column;
padding: 7px;
margin-top: 5px !important;
padding-left: 5px;
background-color: #e0f7fa;
border-left: 5px solid #7AB800 !important;
border-radius: 4px;
`;

export const StyledLabel = styled.label`
font-size: 14px !important;
display: flex;
align-items: center;
gap: 5px;
 div {
  font-size: 15px !important;
 }
`
export const StyledLabelError = styled(Label)`
border: 1px solid #e0b4b4 !important;
color: #9f3a38 !important;
position: absolute !important;
margin-top: 0.5em !important;
background: #fff!important;
max-width: 300px;
z-index: 99;
`